
import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../api/api";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

export default function SparesConsumables({ AssetID = 1 }) {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    materialType: null,
    partNo: null,
    partDesc: "",
    reqQty: "",
    uom: "",
    frequency: "",
    storeQty: "",
    category: "",
    description: "",
    itemId: "",
    assetId: AssetID,
  });
  const [partNoOptions, setPartNoOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sparesList, setSparesList] = useState([]);
  const [consumablesList, setConsumablesList] = useState([]);
  const [filterType, setFilterType] = useState("both");
  const [searchTerm, setSearchTerm] = useState("");

  const materialOptions = [
    { value: "spares", label: "Spares" },
    { value: "consumable", label: "Consumables" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMaterialTypeChange = async (selected) => {
    setFormData((prev) => ({ ...prev, materialType: selected, partNo: null, partDesc: "", itemId: "", uom: "", }));
    if (selected) {
      setLoading(true);
      try {
        const response = await api.GETItemMaster("admin", selected.value);
        const items = response.Table || [];
        const options = items.map((item) => ({
          value: item.Item_No,
          label: `${item.Item_No} - ${item.Item_Desc1}`,
          desc: item.Item_Desc1,
          itemId: item.itemid,
          uom: item.Uom,

        }));
        setPartNoOptions(options);
      } catch (error) {
        console.error("Error fetching item master:", error);
        setPartNoOptions([]);
      } finally {
        setLoading(false);
      }
    } else {
      setPartNoOptions([]);
    }
  };

  const handlePartNoChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      partNo: selected,
      partDesc: selected ? selected.desc : "",
      itemId: selected ? selected.itemId : "",
      uom: selected ? selected.uom : "",
    }));
  };

  const fetchSparesData = async () => {
  try {
    const response = await api.EditAssetspares_API(AssetID);
    console.log("Full API Response:", response);

    // ✅ Safely extract table data
    const table =
      response?.EditAssetspares_APIjs?.Table ||
      response?.Table ||
      response?.data?.EditAssetspares_APIjs?.Table ||
      [];

    console.log("Parsed Table Data:", table);

    // ✅ Filter only items for this AssetId
    const filteredByAsset = table.filter(
      (x) => String(x.AssetId) === String(AssetID)
    );

    // ✅ Split by MaterialType (case-insensitive)
    const spares = filteredByAsset.filter(
      (x) => (x.MaterialType || "").trim().toLowerCase() === "spares"
    );
    const consumables = filteredByAsset.filter(
      (x) => (x.MaterialType || "").trim().toLowerCase() === "consumables"
    );

    // ✅ Update state
    setSparesList(spares);
    setConsumablesList(consumables);

    console.log("✅ Spares Loaded:", spares.length);
    console.log("✅ Consumables Loaded:", consumables.length);
  } catch (error) {
    console.error("❌ Error fetching spares data:", error);
    alert("Failed to load spares/consumables data.");
    setSparesList([]);
    setConsumablesList([]);
  }
};



  // Load once when AssetID changes
  useEffect(() => {
    if (AssetID) {
      fetchSparesData();
    }
  }, [AssetID]);



  const handleSave = async () => {
    if (!formData.materialType || !formData.partNo) {
      alert("Please select Material Type and Part No!");
      return;
    }

    try {
      const payload = {
        AssetId: formData.assetId || AssetID,
        ItemId: formData.itemId || "",
        PartNo: formData.partNo.value || "",
        PartDesc: formData.partDesc || "",
        Req_Qty: parseFloat(formData.reqQty) || 0,
        Frequency: formData.frequency || "NA",
        Apro_Cost: parseFloat(formData.aproCost) || 0,
        StoresQty: parseFloat(formData.storeQty) || 0,
        Category: formData.category || "NA",
        Description: formData.description || "NA",
        MaterialType: formData.materialType.label, // preserve case
      };


      console.log("Saving Payload:", payload);

      const response = await api.SaveAssetspares(payload);
      console.log("Save response:", response);

      if (response?.SaveAssetsparesAPIjs) {
        alert("Data saved successfully!");
        setShowModal(false);
        setFormData({
          materialType: null,
          partNo: null,
          partDesc: "",
          reqQty: "",
          frequency: "",
          storeQty: "",
          category: "",
          description: "",
          itemId: "",
          aproCost: "",
          assetId: AssetID,
        });
        setPartNoOptions([]);
        fetchSparesData();
      } else {
        alert("Save failed! No response from server.");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Failed to save data. Please try again.");
    }
  };


  const filteredData = () => {
  let data = [];

  if (filterType === "spares") data = sparesList;
  else if (filterType === "consumables") data = consumablesList;
  else data = [...sparesList, ...consumablesList]; // Both

  // ✅ Apply search filter (optional)
  if (searchTerm) {
    data = data.filter(
      (item) =>
        item.PartNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.PartDesc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.ItemId?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  return data;
};


  const handleDelete = async (spareId) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await api.DeleteAssetspares(spareId);
      alert("Item deleted successfully!");
      fetchSparesData(); // Refresh list
    } catch (error) {
      console.error("Error deleting item:", error);
      alert("Failed to delete item. Please try again.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <h2 >Spares & Consumables</h2>
          <ExcelExport  data={filteredData()} fileName="SparesConsumables" />
        <button
        
          onClick={() => setShowModal(true)}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            padding: "10px 22px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          ➕ New
        </button>
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "20px", alignItems: "center" }}>
        <button
          onClick={() => setFilterType("both")}
          style={{
            backgroundColor: filterType === "both" ? "#007bff" : "#6c757d",
            color: "white",
            padding: "8px 16px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Both
        </button>
        <button
          onClick={() => setFilterType("spares")}
          style={{
            backgroundColor: filterType === "spares" ? "#007bff" : "#6c757d",
            color: "white",
            padding: "8px 16px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Spares
        </button>
        <button
          onClick={() => setFilterType("consumables")}
          style={{
            backgroundColor: filterType === "consumables" ? "#007bff" : "#6c757d",
            color: "white",
            padding: "8px 16px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Consumables
        </button>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px 12px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            width: "200px",
          }}
        />
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
        <thead>
          <tr style={{ backgroundColor: "#f8f9fa" }}>
            <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Material Type</th>
            <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Item ID</th>
            <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Part No</th>
            <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Part Description</th>
            {/* <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Req Qty</th> */}
            {/* <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Frequency</th> */}
            <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Store Qty</th>
            {/* <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Category</th> */}
            {/* <th style={{ padding: "10px", border: "1px solid #ddd", textAlign: "left" }}>Description</th> */}

            <th style={{ padding: "10px", border: "1px solid #ddd" }}>
              Action
            </th>

          </tr>
        </thead>
        <tbody>
          {filteredData().map((item, index) => (
            <tr key={index}>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.MaterialType || "—"}</td>

              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.ItemId}</td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.PartNo}</td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.PartDesc}</td>
              {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.Req_Qty}</td> */}
              {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.Frequency}</td> */}
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.StoresQty}</td>
              {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.category}</td> */}
              {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>{item.Description}</td> */}

              <td
                style={{
                  padding: "10px",
                  border: "1px solid #ddd",
                  textAlign: "center",
                }}
              >
                <button
                  onClick={() => handleDelete(item.SpareId)}
                  style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>

            </tr>
          ))}
          {filteredData().length === 0 && (
            <tr>
              <td colSpan="9" style={{ padding: "20px", textAlign: "center", border: "1px solid #ddd" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            overflowY: "auto",
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "30px 35px",
              borderRadius: "10px",
              width: "500px",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <style>{`
              @keyframes fadeIn {
                from { opacity: 0; transform: scale(0.95); }
                to { opacity: 1; transform: scale(1); }
              }

              label {
                font-weight: 600;
                font-size: 14px;
                color: #333;
                margin-bottom: 8px;
                display: block;
                text-align: left;
              }

              input, textarea {
                width: 100%;
                padding: 8px 10px;
                border: 1px solid #ddd;
                border-radius: 5px;
                font-size: 14px;
                box-sizing: border-box;
                transition: border-color 0.3s ease;
              }

              input:focus, textarea:focus {
                border-color: #007bff;
                outline: none;
                box-shadow: 0 0 5px rgba(0,123,255,0.4);
              }

              textarea {
                resize: vertical;
                min-height: 60px;
              }

              .form-item {
                margin-bottom: 15px;
              }

              .select-item .css-1s2u09g-control {
                border: 1px solid #ddd;
                border-radius: 5px;
                font-size: 14px;
                min-height: 38px;
              }

              .select-item .css-1pahdxg-control {
                border-color: #007bff;
                box-shadow: 0 0 5px rgba(0,123,255,0.4);
              }

              .select-item .css-1uccc91-singleValue {
                text-align: left;
              }

              .select-item .css-319lph-ValueContainer {
                text-align: left;
              }

              .select-item .css-1hb7zxy-IndicatorsContainer {
                display: flex;
                align-items: center;
              }
            `}</style>

            <h3
              style={{
                marginBottom: "20px",
                textAlign: "center",
                color: "#333",
                borderBottom: "2px solid #007bff",
                paddingBottom: "8px",
              }}
            >
              Add Material Details
            </h3>

            <div>
              <div className="form-item select-item">
                <label>Material Type</label>
                <Select
                  options={materialOptions}
                  value={formData.materialType}
                  onChange={handleMaterialTypeChange}
                  placeholder="Select..."
                />
              </div>

              <div className="form-item select-item">
                <label>Part No</label>
                <Select
                  options={partNoOptions}
                  value={formData.partNo}
                  onChange={handlePartNoChange}
                  placeholder="Type to search..."
                  isDisabled={loading}
                  isSearchable={true}
                  isClearable={true}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>

              <div className="form-item">
                <label>Part Description</label>
                <input
                  type="text"
                  name="partDesc"
                  value={formData.partDesc}
                  onChange={handleChange}
                  placeholder="Enter description"
                  readOnly
                />
              </div>

              <div className="form-item">
                <label>UOM</label>
                <input
                  type="text"
                  name="uom"
                  value={formData.uom}
                  readOnly
                  placeholder="UOM"
                />
              </div>


              <div className="form-item">
                <label>Frequency</label>
                <input
                  type="text"
                  name="frequency"
                  value={formData.frequency}
                  onChange={handleChange}
                  placeholder="Enter frequency"
                />
              </div>

              <div className="form-item">
                <label>Qty</label>
                <input
                  type="number"
                  name="storeQty"
                  value={formData.storeQty}
                  onChange={handleChange}
                  placeholder="Enter qty"

                />
              </div>

              <div className="form-item">
                <label>Category</label>
                <input
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  placeholder="Enter category"
                />
              </div>

              <div className="form-item">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter description"
                />
              </div>
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
                borderTop: "1px solid #ddd",
                paddingTop: "15px",
                gap: "10px",
              }}
            >
              <button
                onClick={handleSave}
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "8px 18px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                💾 Save
              </button>

              <button
                onClick={() => setShowModal(false)}
                style={{
                  backgroundColor: "#6c757d",
                  color: "white",
                  padding: "8px 18px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                ✖ Cancel
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}
